import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Query } from '@datorama/akita';
import dayjs from 'dayjs';
import { first, last } from 'lodash-es';
import { map } from 'rxjs/operators';

import { Utils } from '@shared/utils/utils';

import { TimelineState, TimelineStore } from './timeline.store';

@Injectable({ providedIn: 'root' })
export class TimelineQuery extends Query<TimelineState> {
  timeline = toSignal(this.select('items'), { requireSync: true });

  protected store: TimelineStore;

  constructor() {
    const store = inject(TimelineStore);

    super(store);

    this.store = store;
  }

  getStartEndDateTrial() {
    const items = this.getValue().items;

    const startDate = `${first(items)?.contract_start_date.slice(0, 8)}01`;
    let endDate = Utils.dateParse(`${last(items)?.contract_end_date.slice(0, 8)}01`);

    items.forEach((i) => {
      const parsedDate = Utils.dateParse(`${i.contract_end_date.slice(0, 8)}01`);

      if (parsedDate > endDate) {
        endDate = parsedDate;
      }
    });

    return {
      endDate: dayjs(endDate).format('YYYY-MM-DD'),
      startDate,
    };
  }

  getTimelineRange(transformPattern = 'YYYY-MM-DD'): string[] {
    const timelineList = this.getValue().items;

    const timelineRange: string[] = [];

    timelineList.forEach(({ contract_end_date, contract_start_date }) => {
      let startDate = dayjs(contract_start_date);
      const endDate = dayjs(contract_end_date);

      while (startDate.isBefore(endDate)) {
        timelineRange.push(startDate.format(transformPattern));
        startDate = startDate.add(1, 'month');
      }
    });

    return timelineRange;
  }

  selectStartEndDateTrial() {
    return this.select('items').pipe(map(() => this.getStartEndDateTrial()));
  }

  selectTimelineRange(transformPattern = 'YYYY-MM-DD') {
    return this.select('items').pipe(map(() => this.getTimelineRange(transformPattern)));
  }
}
